module.exports = __webpack_public_path__ + "static/nxrt-esports4-9b0a86513061b987cd1209f6cba89f97.png";